var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TRACK_EVENT } from 'shared/utils/mixpanel';
import { useSharedEventDataContext } from '../contexts';
export var useTrackEvent = function () {
    var sharedEventData = useSharedEventDataContext();
    var trackEvent = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var eventProperties = __assign(__assign({}, ((_a = args[3]) !== null && _a !== void 0 ? _a : {})), sharedEventData);
        TRACK_EVENT(args[0], args[1], args[2], eventProperties);
    };
    return trackEvent;
};
